import React, { useCallback, useEffect, useState } from "react";
import InputText from "../../../../components/inputs/InputText";
import AddButton from "../../../../components/headers/AddButton";
import baseUrl from "../../../../api/baseUrl";
import AddProductModal from "../components/AddProductModal";
import AddPurchasePaymentModal from "../components/AddPurchasePaymentModal";
import InputDropSearch from "../../../../components/inputs/InputDropSearch";
import { useNavigate, useParams } from "react-router-dom";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../redux/loader/loaderActions";
function AddPurchase() {
  const [formData, setFormData] = useState<FormData>({
    supplierId: "",
    invoiceNo: "",
    invoiceDate: "",
    netTotal: 0,
    total: 0,
    lastDue: 0,
    lastPayment: 0,
    errors: false,
    product: [],
    payments: [],
  });
  const { ID } = useParams();
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [payments, setPayments] = useState(false);
  const [supplier, setSupplier] = useState<Supplier[]>([]);

  const getSupplierData = useCallback((search: string) => {
    baseUrl
      .get("client/inventory/purchase/searchAllSupplier", {
        headers: { keyword: search },
      })
      .then((response) => {
        setSupplier(response.data.data);
      })
      .catch((error) => {
        console.error(error?.response);
      });
  }, []);
  const getPurchaseData = useCallback((ID: string) => {
    baseUrl
      .get("client/inventory/purchase/findPurchaseById", {
        headers: { purchaseid: ID },
      })
      .then((response) => {
        setFormData(response.data.data);
      })
      .catch((error) => {
        console.error(error?.response);
      });
  }, []);

  useEffect(() => {
    getSupplierData("");
  }, [getSupplierData]);

  useEffect(() => {
    if (ID !== undefined) {
      getPurchaseData(ID);
    }
  }, [ID, getPurchaseData]);

  const searchSupplier = useCallback(
    (e: any) => {
      getSupplierData(e);
    },
    [getSupplierData]
  );

  const handleChange = useCallback((e: any) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }, []);

  const closeAddProductModal = useCallback(() => {
    setOpenAddProduct(false);
  }, []);

  const openAddProductModal = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      setOpenAddProduct(true);
    },
    []
  );

  const closePaymentModal = useCallback(() => {
    setPayments(false);
  }, []);

  const openPaymentModal = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      setPayments(true);
    },
    []
  );

  const addProduct = useCallback(
    (product: Product) => {
      if (ID) {
        setFormData((prevFormData) => {
          const updatedProducts = [...prevFormData.product, product];
          const total = updatedProducts.reduce((sum, product) => {
            const price =
              typeof product.price === "string"
                ? parseFloat(product.price)
                : product.price;
            return sum + price;
          }, 0);
          const totals = prevFormData.payments.reduce((sum, payments) => {
            const price =
              (typeof payments.card === "string"
                ? parseFloat(payments.card)
                : payments.card) +
              (typeof payments.cash === "string"
                ? parseFloat(payments.cash)
                : payments.cash) +
              (typeof payments.discount === "string"
                ? parseFloat(payments.discount)
                : payments.discount);

            return sum + price;
          }, 0);
          console.log(totals);

          return {
            ...prevFormData,
            product: updatedProducts,
            total: total - totals,
          };
        });
      } else {
        setFormData((prevFormData) => {
          const updatedProducts = [...prevFormData.product, product];
          const total = updatedProducts.reduce((sum, product) => {
            const price =
              typeof product.price === "string"
                ? parseFloat(product.price)
                : product.price;
            return sum + price;
          }, 0);

          return {
            ...prevFormData,
            product: updatedProducts,
            total: total,
          };
        });
      }
      closeAddProductModal();
    },
    [closeAddProductModal, ID]
  );
  const removeProductById = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>, id: number) => {
      event.preventDefault();
      setFormData((prevFormData) => {

        // Filter out the product by id
        const updatedProducts = prevFormData.product.filter(
          (product: any) => product?.productId !== id || product.paid
        );

        // Calculate the new total price
        const totalPrice = updatedProducts.reduce((sum, product) => {
          // Convert product.price to a number if it's a string
          const price =
            typeof product.price === "string"
              ? parseFloat(product.price)
              : product.price;
          return sum + price;
        }, 0);

        return {
          ...prevFormData,
          product: updatedProducts,
          total: totalPrice,
        };
      });
    },
    []
  );
  const addPayment = useCallback(
    (payments: Payments) => {
      if (ID) {
        setFormData((prevFormData) => {
          const updatedPayments = [...prevFormData.payments, payments];
          // const total = updatedPayments.reduce((sum, payments) => {
          //   const price =
          //     typeof payments.price === "string"
          //       ? parseFloat(payments.price)
          //       : payments.price;
          //   return sum + price;
          // }, 0);

          return {
            ...prevFormData,
            payments: updatedPayments,
            // total: total,
          };
        });
        closePaymentModal();
      } else {
        setFormData((prevFormData) => {
          const updatedPayments = [...prevFormData.payments, payments];
          // const total = updatedPayments.reduce((sum, payments) => {
          //   const price =
          //     typeof payments.price === "string"
          //       ? parseFloat(payments.price)
          //       : payments.price;
          //   return sum + price;
          // }, 0);

          return {
            ...prevFormData,
            payments: updatedPayments,
            // total: total,
          };
        });
        closePaymentModal();
      }
    },
    [closePaymentModal, ID]
  );
  const navigate = useNavigate();
  const handleSubmit = (e: any) => {
    e.preventDefault();
    setloadeActive();
    if (
      formData.supplierId === "" ||
      formData.invoiceNo === "" ||
      formData.invoiceDate === "" 
      // formData.netTotal <= 0 ||
      // formData.total <= 0 ||
      // formData.product.length <= 0 ||
      // formData.payments.length <= 0
    ) {
      setloadeDeactive();
      setFormData((prevData) => {
        return {
          ...prevData,
          errors: true,
        };
      });
    } else {
      if (ID) {
        baseUrl
          .patch("client/inventory/purchase/updatePurchase", formData, {
            headers: { purchaseid: ID },
          })
          .then((response) => {
            setloadeDeactive();

            navigate("/client/inventory/purchase/all-purchase");
          })
          .catch((error) => {
            console.error(error?.response);
          });
      } else {
        baseUrl
          .post("client/inventory/purchase/createPurchase", formData)
          .then((response) => {
            setloadeDeactive();

            navigate("/client/inventory/purchase/all-purchase");
          })
          .catch((error) => {
            console.error(error?.response);
          });
      }
    }
  };
  return (
    <div className="purchase">
      {openAddProduct && (
        <AddProductModal
          closeModal={() => closeAddProductModal()}
          addProduct={addProduct}
        />
      )}
      {payments && (
        <AddPurchasePaymentModal
          closeModal={() => closePaymentModal()}
          amount={formData}
          addPayment={addPayment}
        />
      )}
      <AddButton button={false} title={"Add Purchase"} />
      <form onSubmit={handleSubmit}>
        <InputDropSearch
          data={supplier}
          name="supplierId"
          label="supplier Name"
          selectName1="supplierName"
          selectName2="suppliercompany"
          selectValue="_id"
          value={formData.supplierId}
          onChange={handleChange}
          onSearch={searchSupplier}
          isDisable={ID !== undefined}
          errors={formData.errors && formData.supplierId === ""}
        />

        <InputText
          name="invoiceNo"
          label="invoice Number"
          value={formData.invoiceNo}
          onChange={handleChange}
          isDisable={ID !== undefined}
          errors={formData.errors && formData.invoiceNo === ""}
        />
        <InputText
          name="invoiceDate"
          label="Invoice Date"
          value={formData.invoiceDate}
          onChange={handleChange}
          type="date"
          isDisable={ID !== undefined}
          errors={formData.errors && formData.invoiceDate === ""}

        />

        <div style={{ height: 40 }}></div>
        <AddButton
          onClick={(e: any) => openAddProductModal(e)}
          title={"Product List"}
          buttonName="Add Product"
        />
        <table className="dtable">
          <thead>
            <tr>
              {tableHeader?.map((item: any, i: number) => (
                <th key={i}>{item?.title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {formData?.product?.map((item: any, i: number) => (
              <tr key={i}>
                <td data-label={tableHeader[0].title}>{i + 1}</td>
                <td data-label={tableHeader[1].title}>{item?.productName}</td>
                <td data-label={tableHeader[2].title}>{item?.quantity}</td>
                <td data-label={tableHeader[3].title}>{item?.unitPrice}</td>
                <td data-label={tableHeader[4].title}>{item?.price}</td>
                <td data-label={tableHeader[5].title}>
                  {!item?.productPaid && (
                    <button
                      onClick={(e) => removeProductById(e, item?.productId)}
                    >
                      Remove
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>

          <tfoot>
            <tr>
              <td colSpan={5}>Paid</td>
              <td>{formData.lastPayment}</td>
            </tr>
            <tr>
              <td colSpan={5}>last Due</td>
              <td>{formData.lastDue}</td>
            </tr>
            <tr>
              <td colSpan={5}>Total payable</td>
              <td>{formData.total}</td>
            </tr>
          </tfoot>
        </table>
        <div style={{ height: 40 }}></div>
        <AddButton
          onClick={(e: any) => openPaymentModal(e)}
          title={"Payment List"}
          buttonName="Add Payment"
        />
        <table className="dtable">
          <thead>
            <tr>
              {tableHeader2?.map((item: any, i: number) => (
                <th key={i}>{item?.title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {formData?.payments?.map((item: Payments, i: number) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{item?.total}</td>
                <td>{item?.discount}</td>
                <td>{item?.netTotal}</td>
                <td>{item?.card}</td>
                <td>{item?.cash}</td>
                <td>{item?.due}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className="sub_button" type="submit">
          Submit
        </button>
      </form>
    </div>
  );
}

export default AddPurchase;
const tableHeader2 = [
  { title: "No" },
  { title: "total" },
  { title: "DIscount" },
  { title: "nettotal" },
  { title: "card" },
  { title: "cash" },
  { title: "due" },
];
interface Product {
  productId: string;
  productName: string;
  quantity: number;
  unitPrice: number;
  price: number;
  paid: Boolean;
}
interface Payments {
  total: number;
  netTotal: number;
  discount: number;
  card: number;
  cash: number;
  due: number;
}

interface FormData {
  supplierId: string;
  invoiceNo: string;
  invoiceDate: string;
  product: Product[];
  payments: Payments[];
  netTotal: number;
  total: number;
  lastDue: number;
  lastPayment: number;
  errors: boolean;
}

interface Supplier {
  _id: string;
  supplierName: string;
  supplierCompany: string;
}

const tableHeader = [
  { title: "No" },
  { title: "Product Name" },
  { title: "Unit" },
  { title: "unit price" },
  { title: "total" },
  { title: "Action" },
];
